import { createAction, props } from '@ngrx/store';
import { TaxJurisdiction } from 'src/app/pages/orders/interfaces/tax-jurisdiction.interface';
import { CheckTaxJurisdiction } from 'src/app/pages/orders/interfaces/check-tax-jurisdiction.interface';

export const checkTaxJurisdiction = createAction(
  '[Tax Jurisdictions] Check',
  props<{ params: CheckTaxJurisdiction }>(),
);

export const checkTaxJurisdictionRequestByKey = createAction(
  '[Tax Jurisdictions] Check Request By Key',
  props<{ key: string }>(),
);

export const checkTaxJurisdictionSuccess = createAction(
  '[Tax Jurisdictions] Check Success',
  props<{ response: TaxJurisdiction[] }>(),
);

export const checkTaxJurisdictionSuccessByKey = createAction(
  '[Tax Jurisdictions] Check Success By Key',
  props<{ key: string; response: TaxJurisdiction[] }>(),
);

export const checkTaxJurisdictionFailure = createAction('[Tax Jurisdictions] Check Failure', props<{ error: any }>());

export const checkTaxJurisdictionFailureByKey = createAction(
  '[Tax Jurisdictions] Check Failure By Key',
  props<{ key: string; error: any }>(),
);

export const setEmptyCache = createAction(
  '[TaxJurisdictions] Set Empty Cache',
  props<{ key: string; response: TaxJurisdiction[] }>(),
);
